import { CallbackComponent } from 'redux-oidc';
import userManager from 'src/userManager';
import { useNavigate } from 'react-router-dom';
import { MeRoutesEnum, RoutesEnum } from 'src/shared/models/enums/routes.enum';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BigLoader } from 'src/shared/components/organisms/bigLoader';
import { User } from 'oidc-client';
import { UserAccountTypeEnum } from 'src/shared/models/enums/userAccountType.enum';
import { isSafeReturnUrl } from 'src/shared/functions/returnUrl';

export const Callback = () => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  return (
    <>
      {/* @ts-expect-error Server Component */}
      <CallbackComponent
        userManager={userManager}
        successCallback={(signedInUser: User) => {
          // Returadressen följde med i OIDC-anropets state och kommer tillbaka här. Saknas den,
          // eller pekar den bort från appen, går vi till startsidan precis som tidigare.
          const returnUrl = (signedInUser?.state as { returnUrl?: unknown } | undefined)?.returnUrl;

          if (isSafeReturnUrl(returnUrl)) {
            navigate(returnUrl);
            return;
          }

          // Användaren tas från argumentet och inte ur redux-storen. Storen hinner inte fyllas
          // innan callbacken körs, så medlemmar hamnade i användargrenen och fick gå omvägen
          // via skyddsrutinen till rätt startsida.
          if (signedInUser?.profile?.accountType === UserAccountTypeEnum.Member) {
            ConsoleHelper.log('CALLBACK FOR MEMBER');
            navigate(MeRoutesEnum.MemberDashboard);
          } else {
            ConsoleHelper.log('CALLBACK FOR USER');
            navigate(RoutesEnum.Dashboard);
          }
        }}
        errorCallback={(error) => {
          navigate(RoutesEnum.Login);
          ConsoleHelper.error(error);
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: `#fff !important`,
          }}
        >
          <BigLoader message={t('common:statusMessages.redirecting')} />
        </Box>
      </CallbackComponent>
    </>
  );
};
